import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service = {
  name: 'Petrobras',
  label: 'Petrobras',
  permissionId: 'petrobras',
  iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  // showDissolveClock: true,
  data: [
  ],
  layers: [
    {
      name: 'Petrobras',
      label: 'Weekly mosaic',
      opacity: 'raster-opacity',
      datetimeId: 'Petrobras',
      secondary: false,
      open: true,
      transparencyLabel: 'Sentinel 2',
      // transparencyMarks: {
      //   0: { label: 'Previous', value: 0 },
      //   100: { label: 'Current', value: 100 }
      // },
      transparencyOptions: {
        label: 'hi'
      },
      hideLabel: true,
      disableToggle: true
    },
    {
      name: 'PetrobrasDrone',
      label: 'UAV',
      opacity: 'raster-opacity',
      // datetimeId: 'Petrobras',
      secondary: false,
      open: true,
      transparencyLabel: 'Neovision UAV',
      hideLabel: true,
      disableToggle: true
    },    
  ],
  locations: [
    {
      name: 'Guara',
      label: 'Guara',
      latitude: -20.43885,
      longitude: -47.85576,
      zoom: [15]
    },
  ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/Petrobras.js